import httpClient from '@/services/httpClient';

export default {
  getSpotlightInfo: (language, vin, options) => httpClient.get(`/api/spotlight/${language}/${vin}`, options),
  fetchSpotlightCategories: ({ options }) => httpClient.get('/api/v2/spotlight/categories', options),
  fetchSpotlightHeroes: ({ options }) => httpClient.get('/api/v2/spotlight/heroes', options),
};
